(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment-v2/assets/javascripts/fraction-payment-v2.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment-v2/assets/javascripts/fraction-payment-v2.js');
"use strict";


const {
  useCallback,
  useEffect,
  useState
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useLocation
} = ReactRouterDOM;
const {
  useMediaQuery
} = svs.components.lbUtils;
const {
  breakpoints,
  BREAKPOINT_AM
} = useMediaQuery;
const {
  BottomSheetIntersersect
} = svs.components.lbUi.bottomSheetIntersect;
const {
  createFraction
} = svs.components.payment.createFraction;
const {
  createFractionPaymentFlow
} = svs.components.wagerPaymentFlow.fractionFlow;
const {
  executePayment
} = svs.components.wagerPaymentFlow.executePayment;
const {
  games
} = svs.components.marketplaceData;
const {
  PRIVATE,
  RETAILER
} = svs.components.marketplaceData.constants.groupTypeNames;
const {
  PayButton
} = svs.components.marketplace.fractionPayment;
const {
  selectors
} = svs.components.marketplaceData;
const {
  useTriggerPayment
} = svs.components.marketplace.fractionPayment;
const {
  useCantBuy,
  useHasReachedMaxFractionsPerMember
} = svs.components.marketplace.fractionPayment;
const {
  QS_FRACTION_DATA
} = svs.components.marketplaceShared.sharedConstants.constants;
const {
  FRACTION_PAYMENT_SUCCESS
} = svs.components.marketplaceShared.sharedConstants.constants;

const FractionPaymentV2 = _ref => {
  let {
    activatedDrawId,
    block,
    className,
    containerId,
    game,
    groupId,
    hasSnackbar,
    isSmall,
    isBrowseGames
  } = _ref;
  const dispatch = useDispatch();
  const location = useLocation();
  const currentUserId = useSelector(state => state.customerId);
  const isCurrentUserAuthenticated = Boolean(currentUserId);
  const group = useSelector(state => selectors.teams.selectTeam(state, {
    id: groupId
  }));
  const isSmallDevice = useMediaQuery.useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const {
    currentUserNumberOfShares,
    fractionPrice,
    maxFractionsPerMember,
    maxFractions,
    isSoldOut,
    productId
  } = game;
  const {
    triggerPayment,
    clearPaymentTrigger
  } = useTriggerPayment(activatedDrawId, groupId, isCurrentUserAuthenticated);
  const [fractionPaymentInProgress, setFractionPaymentInProgress] = useState(false);
  const cantBuy = useCantBuy({
    group,
    fractionPaymentInProgress,
    game,
    currentUserNumberOfShares
  });
  const hasReachedMaxFractionsPerMember = useHasReachedMaxFractionsPerMember({
    group,
    maxFractions,
    maxFractionsPerMember,
    currentUserNumberOfShares
  });
  const triggerNewPaymentFlow = useCallback(async () => {
    if (fractionPaymentInProgress) {
      return;
    }
    setFractionPaymentInProgress(true);
    const fraction = createFraction().setActivatedDrawId(activatedDrawId).setContainerId(containerId).setGroupId(groupId).setPrice(fractionPrice).setProductId(productId);
    const paymentBuilder = createFractionPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      fraction
    });
    const [, error] = await executePayment(paymentBuilder, {
      userContext: {
        returnUrl: "".concat(location.pathname, "?", "".concat(QS_FRACTION_DATA, "=").concat(activatedDrawId, "_").concat(groupId)),
        callback: () => {
          if (group.type === RETAILER || isBrowseGames) {
            dispatch(games.actions.fetchActivatedDrawAction(groupId, activatedDrawId, containerId));
          } else if (group.type === PRIVATE) {
            dispatch(games.actions.fetchGameAction(groupId, containerId));
          }
        }
      }
    });
    if (!error) {
      dispatch({
        type: FRACTION_PAYMENT_SUCCESS,
        memberId: currentUserId,
        groupId,
        fractionsBought: 1,
        activatedDrawId
      });
    }
    setFractionPaymentInProgress(false);
  }, [activatedDrawId, containerId, currentUserId, dispatch, fractionPaymentInProgress, fractionPrice, group.type, groupId, isBrowseGames, location.pathname, productId]);
  useEffect(() => {
    if (triggerPayment) {
      clearPaymentTrigger();
      triggerNewPaymentFlow();
    }
  }, []);
  if (!hasSnackbar) {
    return React.createElement("div", {
      className: className
    }, React.createElement(PayButton, {
      block: block,
      cantBuy: cantBuy,
      fractionPrice: fractionPrice,
      fractionPurchaseLoading: fractionPaymentInProgress,
      isSmall: isSmall,
      onClick: triggerNewPaymentFlow
    }));
  }
  return React.createElement("div", {
    className: className
  }, isSmallDevice && !hasReachedMaxFractionsPerMember && !isSoldOut && React.createElement("div", {
    className: "snackbar-container"
  }, React.createElement(BottomSheetIntersersect, {
    intersectId: "snackbar-selector"
  }, React.createElement("div", {
    className: "margin-top-1 margin-bottom-1 margin-right margin-left"
  }, React.createElement(PayButton, {
    block: block,
    cantBuy: cantBuy,
    fractionPrice: fractionPrice,
    fractionPurchaseLoading: fractionPaymentInProgress,
    isCurrentUserAuthenticated: isCurrentUserAuthenticated,
    isSmall: isSmall,
    onClick: triggerNewPaymentFlow
  })))), React.createElement("div", {
    className: className,
    "data-testid": "qa-fraction-snackbar",
    id: "snackbar-selector"
  }, React.createElement(PayButton, {
    block: block,
    cantBuy: cantBuy,
    fractionPrice: fractionPrice,
    fractionPurchaseLoading: fractionPaymentInProgress,
    isCurrentUserAuthenticated: isCurrentUserAuthenticated,
    isSmall: isSmall,
    onClick: triggerNewPaymentFlow
  })));
};
FractionPaymentV2.defaultProps = {
  block: true,
  className: '',
  hasSnackbar: false,
  isSmall: false
};

setGlobal('svs.components.marketplace.fractionPayment.FractionPaymentV2', FractionPaymentV2);

 })(window);